import React, { useState } from 'react'
import { InventoryList } from './InventoryList'
import { Inventory } from 'domain/entities/Inventory'
import { useCreateInventory } from 'presentation/hooks/inventory/useCreateInventory'
import { useUpdateInventory } from 'presentation/hooks/inventory/useUpdateInventory'
import { FormValues, InventoryForm } from './InventoryForm'
import { useFetchInventories } from 'presentation/hooks/inventory/useFetchInventories'
import { Button } from '../../components/Button/Button'

export const InventoryPage: React.FC = () => {
  const [creating, setCreating] = useState(false)
  const [editingInventory, setEditingInventory] = useState<Inventory | null>(
    null
  )

  const { createInventory } = useCreateInventory()
  const { updateInventory } = useUpdateInventory()
  const { data = [], loading, refetch } = useFetchInventories()

  const handleSubmit = async (values: FormValues) => {
    try {
      if (editingInventory) {
        await updateInventory(editingInventory.id, values)
      } else {
        await createInventory(values)
      }
      setCreating(false)
      refetch()
      setEditingInventory(null)
    } catch (e) {
      console.error(e)
    }
  }

  const handleCancel = () => {
    setCreating(false)
    setEditingInventory(null)
  }

  return (
    <div>
      {(creating || editingInventory) && (
        <Button type="button" variant="back" onClick={handleCancel}>
          Back to inventory list
        </Button>
      )}

      <h1>Inventories</h1>

      {creating || editingInventory ? (
        <InventoryForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          initialData={
            editingInventory && {
              title: editingInventory.title,
              id: editingInventory.id,
            }
          }
        />
      ) : (
        <>
          <button className="btn-primary" onClick={() => setCreating(true)}>
            Create Inventory
          </button>
          <InventoryList
            onEdit={(inventory) => setEditingInventory(inventory)}
            data={data}
            loading={loading}
            refetch={refetch}
          />
        </>
      )}
    </div>
  )
}
